<template>
  <div>
    <KTCodePreview v-bind:title="'Danh mục chỉ tiêu'" class="cat-target-list">
      <template v-slot:toolbar>
        <div class="d-flex flex-wrap justify-content-end">
          <!-- Lối vào màn Duyệt (người dùng chốt 01/10/2026 thay mục menu riêng của SRS 10.5);
               hiện với mọi người vào được màn này (quyền VIEW). -->
          <b-button
            v-bind:style="btnCreate"
            size="sm"
            variant="outline-primary"
            class="ml-3 mb-1"
            :to="{ name: 'pending-cat-target' }"
          >
            <i style="font-size: 1rem" class="fas fa-check-double"></i>Duyệt danh
            mục chỉ tiêu
          </b-button>
          <!-- FR-801 / SRS 10.4: chỉ hiện khi có UPDATE và cờ `cat-target-go-live-import` đang bật. -->
          <b-button
            v-if="canUpdate && importOpen"
            v-bind:style="btnCreate"
            size="sm"
            variant="outline-primary"
            class="ml-3 mb-1"
            @click="$refs.importModal.show()"
          >
            <!-- SRS 10.1 "Nạp tệp go-live" → "Import excel" cho đồng bộ hệ thống (người dùng chốt
                 01/10/2026). -->
            <i style="font-size: 1rem" class="far fa-file-excel"></i>Import excel
          </b-button>
          <b-button
            v-if="canUpdate"
            v-bind:style="btnCreate"
            size="sm"
            variant="primary"
            class="ml-3 mb-1"
            @click="openForm(null)"
          >
            <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm danh
            mục chỉ tiêu
          </b-button>
        </div>
      </template>
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col cols="12" md="5" lg="4" class="mb-2">
            <b-input
              placeholder="Tìm theo mã hoặc tên"
              v-model="searchName"
              class="btn-sm"
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col cols="auto" class="mb-2">
            <b-button
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              :disabled="onLoading"
              @click="onFilter()"
              >Lọc</b-button
            >
          </b-col>
        </b-row>

        <b-table
          :items="listData"
          :fields="fields"
          bordered
          hover
          responsive
          show-empty
          :busy="onLoading"
          empty-text="Chưa có danh mục chỉ tiêu nào."
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
          </template>
          <template v-slot:cell(code)="row">
            <span class="text-break">{{ row.item.code }}</span>
          </template>
          <template v-slot:cell(name)="row">
            <p class="name-clamp mb-0 text-break" :title="row.item.name">
              {{ row.item.name }}
            </p>
          </template>
          <template v-slot:cell(effectiveFrom)="row">
            {{ toClientDate(row.item.effectiveFrom) }}
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <!-- "Chi tiết" (SRS ghi "Thành viên", chủ repo đổi 02/10/2026) hiện với mọi người có VIEW; Sửa/Xóa chỉ khi có UPDATE (SRS 10.1) -->
                <b-dropdown-item @click="goDetail(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon-eye"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item v-if="canUpdate" @click="openForm(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Sửa
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="canUpdate"
                  :disabled="isSubmitting('delete')"
                  @click="confirmDelete(row.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col cols="12" md="4">
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số: {{ totalItems }}
            </p>
          </b-col>
          <b-col cols="12" md="8">
            <b-pagination-nav
              class="custom-pagination"
              v-show="totalPages >= 2"
              :disabled="onLoading"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              align="right"
              first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
              prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
              next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
              last-class="page-item-last btn btn-icon btn-sm my-1 "
              page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
            >
              <template v-slot:first-text>
                <span><i class="ki ki-bold-double-arrow-back icon-xs"></i></span>
              </template>
              <template v-slot:prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>
              <template v-slot:next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>
              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </b-col>
        </b-row>

        <!-- Form Thêm/Sửa (SRS 10.1) -->
        <b-modal
          ref="formModal"
          :title="form.id ? 'Sửa danh mục chỉ tiêu' : 'Thêm danh mục chỉ tiêu'"
          hide-footer
          :no-close-on-backdrop="isSaving"
          :no-close-on-esc="isSaving"
          :hide-header-close="isSaving"
          @shown="focusFirstInput"
        >
          <b-form-group>
            <label class="font-weight-bold"
              >Mã danh mục chỉ tiêu <span class="text-danger">*</span></label
            >
            <b-form-input
              ref="codeInput"
              size="sm"
              v-model="form.code"
              maxlength="50"
              :disabled="!!form.id || isSaving"
            ></b-form-input>
            <b-form-text v-if="!form.id">
              Chữ in hoa không dấu A–Z, số 0–9 và dấu gạch dưới; không sửa được
              sau khi tạo.
            </b-form-text>
          </b-form-group>
          <b-form-group>
            <label class="font-weight-bold"
              >Tên danh mục chỉ tiêu <span class="text-danger">*</span></label
            >
            <b-form-input
              ref="nameInput"
              size="sm"
              v-model="form.name"
              maxlength="255"
              :disabled="isSaving"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label class="font-weight-bold"
              >Ngày hiệu lực <span class="text-danger">*</span></label
            >
            <date-picker
              class="form-control form-control-sm"
              :config="dpEffectiveFrom"
              v-model="form.effectiveFrom"
              :disabled="isSaving"
            ></date-picker>
          </b-form-group>
          <div class="mt-3 d-flex flex-wrap">
            <SaveButton
              type="button"
              class="mr-2 mb-1"
              :is-busy="isSaving"
              @click="onSave(false)"
            />
            <b-button
              size="sm"
              variant="secondary"
              class="mb-1"
              :disabled="isSaving"
              @click="$refs.formModal.hide()"
              >Hủy</b-button
            >
          </div>
        </b-modal>
      </template>
    </KTCodePreview>
    <ImportGoLiveModal ref="importModal" @saved="fetchData" />
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import SaveButton from '@/view/components/common/SaveButton.vue';
import ImportGoLiveModal from '@/view/components/cat-target/ImportGoLiveModal.vue';
import { CAT_TARGET_IMPORT_FLAG } from '@/utils/constants';
import submitLockMixin from '@/view/mixins/submit-lock.mixins';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';
import {
  makeToastFaile,
  makeToastSuccess,
  getApiErrorMessage,
  isFeatureActive,
} from '@/utils/common';
import { showDeleteAlert, showConfirmNotify } from '@/utils/sweet-alert2';
import {
  DP_CONFIG,
  DATE_FORMAT,
  YEAR_MONTH_DAY_FORMAT,
  formatSpecificDate,
  getAddDate,
} from '@/utils/date';

// t102962 — Màn 1 Danh sách danh mục chỉ tiêu (SRS 10.1, FR-101…104, FR-602; Bổ sung 01 C29).
const API = 'v2/cat-targets';
const PAGE_SIZE = 20;
// Bổ sung 01 RULE-20 — API đòi xác nhận khi dời ngày bắt đầu muộn hơn thành viên sớm nhất.
const EFFECTIVE_FROM_CONFIRM_REQUIRED = 'CAT_TARGET_EFFECTIVE_FROM_CONFIRM_REQUIRED';

const emptyForm = () => ({ id: null, code: '', name: '', effectiveFrom: '' });

export default {
  mixins: [submitLockMixin],
  components: { KTCodePreview, VclTable, SaveButton, ImportGoLiveModal },
  data() {
    return {
      listData: [],
      onLoading: false,
      listSeq: 0,
      importOpen: false,
      btnCreate: { fontWeight: '600!important' },
      totalPages: 1,
      totalItems: 0,
      searchName: '',
      // Từ khóa đã bấm Lọc — phân trang dùng cái này, không dùng chữ đang gõ dở trong ô tìm.
      appliedSearch: '',
      linkGen: (pageNum) => (pageNum === 1 ? '?' : `?page=${pageNum}`),
      form: emptyForm(),
      // RULE-19: ô ngày chỉ nhận 01/01/2015 … hôm nay + 365 (SRS mục 10)
      dpEffectiveFrom: {
        ...DP_CONFIG.date,
        minDate: '2015-01-01',
        maxDate: formatSpecificDate(getAddDate(365), DATE_FORMAT, YEAR_MONTH_DAY_FORMAT),
      },
      fields: [
        {
          key: 'code',
          label: 'Mã',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%', minWidth: '120px' },
          tdClass: 'align-middle',
        },
        {
          key: 'name',
          label: 'Tên danh mục chỉ tiêu',
          thStyle: { fontWeight: 600, color: '#181c32', width: '55%', minWidth: '200px' },
          tdClass: 'align-middle',
        },
        {
          key: 'effectiveFrom',
          label: 'Hiệu lực từ',
          thStyle: { fontWeight: 600, color: '#181c32', width: '17%', minWidth: '100px' },
          thClass: 'text-center',
          tdClass: 'text-center align-middle',
        },
        {
          key: 'actions',
          label: '',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'align-middle',
        },
      ],
    };
  },
  computed: {
    canUpdate() {
      return this.checkPermission('CAT_TARGET_UPDATE');
    },
    // Khóa cả nhóm control của form khi đang lưu (03-frontend §3, rule 12 mục 9.1).
    isSaving() {
      return this.isSubmitting('save');
    },
  },
  watch: {
    // Phân trang (use-router) và Back/Forward của trình duyệt đều đổi `?page` → tải theo URL.
    '$route.query.page'() {
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
    // FR-801: nút nạp tệp chỉ hiện khi cờ bật; API vẫn tự chặn (403) nếu cờ tắt.
    isFeatureActive(CAT_TARGET_IMPORT_FLAG).then((active) => {
      this.importOpen = active;
    });
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Sản phẩm' },
      { title: 'Danh mục chỉ tiêu' },
    ]);
  },
  methods: {
    checkPermission(condition) {
      return localData.checkPermission(condition);
    },
    toClientDate(date) {
      return formatSpecificDate(date, YEAR_MONTH_DAY_FORMAT, DATE_FORMAT);
    },
    currentPage() {
      return Number(this.$route.query.page) || 1;
    },
    fetchData() {
      // Back/Forward bấm nhanh gọi chồng request: chỉ nhận kết quả của lần gọi mới nhất.
      const seq = ++this.listSeq;
      this.onLoading = true;
      const page = this.currentPage();
      const params = { page, limit: PAGE_SIZE, searchName: this.appliedSearch };
      ApiService.query(API, { params })
        .then(({ data }) => {
          if (seq !== this.listSeq) {
            return;
          }
          this.totalPages = data.data.totalPage;
          this.totalItems = data.data.totalRow;
          this.listData = data.data.dataset;
          // Trang đang đứng không còn dòng (vd vừa xóa dòng cuối của trang cuối) → về trang cuối.
          if (!this.listData.length && this.totalItems > 0 && page > this.totalPages) {
            this.goToPage(this.totalPages);
          }
        })
        .catch((err) => {
          if (seq === this.listSeq) {
            makeToastFaile(getApiErrorMessage(err));
          }
        })
        .finally(() => {
          if (seq === this.listSeq) {
            this.onLoading = false;
          }
        });
    },
    // Chỉ gọi API khi Enter/bấm Lọc; đang tải thì bỏ qua để bấm dồn không bắn nhiều request.
    onFilter() {
      if (this.onLoading) {
        return;
      }
      this.appliedSearch = this.searchName;
      if (this.currentPage() === 1) {
        this.fetchData();
        return;
      }
      // Đang ở trang ≥ 2: về trang 1, watch `$route.query.page` tự tải (không gọi hai lần).
      this.goToPage(1);
    },
    goToPage(page) {
      const query = page > 1 ? { page } : {};
      this.$router.push({ name: 'list-cat-target', query }).catch(() => {});
    },
    goDetail(item) {
      this.$router.push({ name: 'detail-cat-target', query: { id: item.id } });
    },
    openForm(item) {
      this.form = item
        ? {
            id: item.id,
            code: item.code,
            name: item.name,
            effectiveFrom: this.toClientDate(item.effectiveFrom),
          }
        : emptyForm();
      this.$refs.formModal.show();
    },
    focusFirstInput() {
      const input = this.form.id ? this.$refs.nameInput : this.$refs.codeInput;
      if (input) {
        input.focus();
      }
    },
    onSave(confirmEffectiveFromChange) {
      return this.withSubmitLock('save', async () => {
        const payload = {
          code: this.form.code,
          name: this.form.name,
          effectiveFrom: formatSpecificDate(
            this.form.effectiveFrom,
            DATE_FORMAT,
            YEAR_MONTH_DAY_FORMAT,
          ),
        };
        try {
          const { data } = this.form.id
            ? await ApiService.put(API, {
                ...payload,
                id: this.form.id,
                confirmEffectiveFromChange,
              })
            : await ApiService.post(API, payload);
          makeToastSuccess(data.message);
          this.$refs.formModal.hide();
          this.fetchData();
        } catch (err) {
          const code =
            err && err.response && err.response.data && err.response.data.code;
          if (code === EFFECTIVE_FROM_CONFIRM_REQUIRED) {
            // Hỏi sau khi nhả khóa để "Vẫn lưu" gửi lại được qua cùng lock.
            this.$nextTick(() => this.confirmEffectiveFromChange(getApiErrorMessage(err)));
            return;
          }
          makeToastFaile(getApiErrorMessage(err));
        }
      });
    },
    // Bổ sung 01 C29 — hiện đúng câu API trả về; "Vẫn lưu" thì gửi lại kèm xác nhận.
    confirmEffectiveFromChange(message) {
      showConfirmNotify({
        title: 'Xác nhận đổi ngày hiệu lực',
        text: message,
        actionName: 'Vẫn lưu',
      }).then((result) => {
        if (result && result.isConfirmed) {
          this.onSave(true);
        }
      });
    },
    confirmDelete(item) {
      showDeleteAlert(
        `Xóa danh mục chỉ tiêu ${item.code}?`,
        'Chỉ xóa được danh mục chỉ tiêu chưa từng có thành viên.',
        item,
        this.deleteItem,
      );
    },
    deleteItem(item) {
      return this.withSubmitLock('delete', async () => {
        // ApiService.delete tự hiện toast lỗi rồi resolve bằng đối tượng lỗi (không reject,
        // src/core/services/api.service.js:170-190) — không có `data` thì dừng, không toast lần hai.
        const response = await ApiService.delete(`${API}/${item.id}`);
        if (!response || !response.data) {
          return;
        }
        makeToastSuccess(response.data.message);
        this.fetchData();
      });
    },
  },
};
</script>

<style scoped>
.name-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
/* 3 nút toolbar nằm một hàng bên phải; khung chung đặt toolbar `col-md-6` + căn giữa nên nút
   bị rớt dòng. Màn hẹp vẫn xuống dòng được (flex-wrap), căn phải. */
.cat-target-list ::v-deep .card-header > .card-title {
  flex: 1 1 auto;
  min-width: 0;
}
.cat-target-list ::v-deep .card-header > .card-toolbar {
  flex: 0 1 auto;
  width: auto;
  max-width: 100%;
}
.cat-target-list ::v-deep .card-header .example-tools {
  justify-content: flex-end !important;
}
</style>
